export enum TABLE_ACTIONS {
  TABLE_SEARCH = 'Table Search',
  NEW = 'New',
  ACTIONS = 'Actions',
  COLUMNS_PRESETS = 'Column Presets',
  SAVED_FILTERS = 'Saved Filters',
  GRID_VIEW_SETTINGS = 'Grid View Settings',
  ROW_SELECTED = 'Rows Selected',
  FULL_EDIT_MODE = 'Full Edit Mode',
}